module.exports = __webpack_public_path__ + "static/media/perla_ramos_2.044bfcb7.jpg";